import AssetsList from './assetsList';

export default AssetsList;



// WEBPACK FOOTER //
// ./src/components/cards/assetsList/index.js